<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';

export default {
  name: "EditResidentModal",
  props: {
    condoId: {
      type: String,
      required: true,
    },
    residentData: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        unit_number: '',
        phone_number: '',
      }),
    },
  },
  data() {
    return {
      form: {
        name: '',
        unit_number: '',
        phone_number: '',
      },
      isSaving: false,
    };
  },
  created() {
    // Initialize form with existing data
    this.form = { ...this.residentData };
  },
  methods: {
    ...mapActions('condoMngt', ['editResident']),
    useAlert,

    async handleSave() {
      this.isSaving = true;
      try {
        await this.editResident({
          condoId: this.condoId,
          residentId: this.residentData.resident_id,
          payload: this.form,
        });

        this.useAlert('Resident updated successfully.');
        this.$emit('updated');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        if (Array.isArray(err)) {
          this.useAlert(err.join('\n'));
        } else {
          this.useAlert('Failed to update resident. Please try again.');
        }
      } finally {
        this.isSaving = false;
      }
    },
  },
  watch: {
    residentData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.form = { ...newVal };
        }
      },
    },
  },
};
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-96 max-h-[80vh] overflow-y-auto">
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">Edit Resident</h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <!-- Form fields -->
      <div class="space-y-4">
        <div>
          <label class="block mb-1 text-slate-700 dark:text-slate-300">Full Name</label>
          <input
            v-model="form.name"
            type="text"
            class="w-full border border-slate-300 dark:border-slate-600 rounded-lg p-2 bg-white dark:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-woot-500"
            placeholder="Enter full name"
          />
        </div>

        <div>
          <label class="block mb-1 text-slate-700 dark:text-slate-300">Unit Number</label>
          <input
            v-model="form.unit_number"
            type="text"
            class="w-full border border-slate-300 dark:border-slate-600 rounded-lg p-2 bg-white dark:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-woot-500"
            placeholder="Enter unit number"
          />
        </div>

        <div>
          <label class="block mb-1 text-slate-700 dark:text-slate-300">Phone Number</label>
          <input
            v-model="form.phone_number"
            type="text"
            class="w-full border border-slate-300 dark:border-slate-600 rounded-lg p-2 bg-white dark:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-woot-500"
            placeholder="Enter phone number"
          />
        </div>
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-6">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button
          :is-loading="isSaving"
          color-scheme="primary"
          icon="save"
          @click="handleSave"
        >
          Save Changes
        </woot-button>
      </div>
    </div>
  </div>
</template>
